import React from 'react';
import { Box, Typography } from '@mui/material';

function DSO() {

    return (
        <Box className="container">
            <Typography className="description">
            A metric that measures the average number of days it takes to collect payment after a sale.
            </Typography>
            
        </Box>
    );
}

export default DSO